// Angular Material Imports
import {MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition,} from '@angular/material/snack-bar'

export interface ISnackbarData {
	message: string
	type: ESnackbarType
	action: string
	hasIcon: boolean
}

export interface ISnackbar {
	message: string
	action?: string
	duration?: number
	hasIcon?: boolean
	horizontalPosition?: MatSnackBarHorizontalPosition
	verticalPosition?: MatSnackBarVerticalPosition
}

export interface ISnackbarCore {
	classes: Array<string>
	type: ESnackbarType
	message: string
	action?: string
	duration?: number
	hasIcon?: boolean
	horizontalPosition?: MatSnackBarHorizontalPosition
	verticalPosition?: MatSnackBarVerticalPosition
}

export enum ESnackbarType {
	success = 'success',
	green = 'green',
	error = 'error',
	warning = 'warning',
}
